import React from 'react'

export default function ShareExpired() {

  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <p className="text-2xl text-red-500">You have to use the shared link to login again.</p>
    </div>
  )
}